__webpack_require__.p = "https://static1.wolfeu.website.svc.wolf.eu/bundles/frontend/dist/wolf/";